var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import jexl from 'jexl';
import { convertToDate, E_DATE_TYPE, getNow, parseISOToMillis } from 'src/shared/helpers/dateHelpers';
import { getPropsByKeyPath, valueExist } from 'src/shared/helpers/objHelpers';
import { E_IDENTITY_STATUS } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/CaseInformation/types';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { EButtonType } from 'src/ui/components/button/Button';
import { COLORS } from 'src/shared/styles/colors';
import { APPLICANT_NUMBER_PLACEHOLDER } from 'src/redux/cases/constants';
import { mergeFiles } from 'src/redux/cases/helpers/filesParser';
import { E_FILE_TYPE } from 'src/redux/core/types';
import { MAX_APPLICANTS_TO_DISPLAY } from 'src/shared/constants';
import { generateUUID } from 'src/shared/helpers/stringHelpers';
import { E_COLUMN_SEARCH_TYPE } from '../types/casesTypes';
// Lock timeout which is 2x the SSE timeout
var LOCK_TIMEOUT_MS = 10 * 60 * 1000; // 10min
export var convertTextPartsToSetText = function (textParts, delimiter) {
    var set = new Set();
    var text = null;
    textParts.forEach(function (textPart) { return set.add(textPart); });
    set.forEach(function (textPart) { return (text = text ? "".concat(text).concat(delimiter).concat(textPart) : textPart); });
    return text || '';
};
export var checkIfCaseIsLocked = function (userInfo, doc) {
    var _a;
    var isLocked = false;
    if (userInfo) {
        var preferred_username = userInfo.preferred_username;
        var _b = ((_a = doc.content) === null || _a === void 0 ? void 0 : _a.currentLock) || {}, startTime = _b.startTime, refreshTime = _b.refreshTime, user = _b.user;
        if (startTime && (user === null || user === void 0 ? void 0 : user.username)) {
            var nowTime = getNow();
            var lockTime = parseISOToMillis(refreshTime);
            var isLockedForAnotherUser = user.username !== preferred_username;
            isLocked = nowTime - lockTime < LOCK_TIMEOUT_MS && isLockedForAnotherUser;
        }
    }
    return isLocked;
};
export var buildSearchCasesAndColumns = function (userInfo, cases, columns, i18n) {
    return cases.map(function (doc) {
        var _a, _b, _c;
        var columnValues = columns.map(function (col) {
            var keyMapForValue = col.keyMapForValue, type = col.type, style = col.style, delimiter = col.delimiter;
            var finalDelimiter = delimiter || ' ';
            var text = null;
            var textParts = [];
            keyMapForValue.forEach(function (key) {
                if (key.source === 'productShortLabel') {
                    var value = getPropsByKeyPath(i18n.keyValueMap, "filter.product.shortLabel");
                    text = (value === null || value === void 0 ? void 0 : value[doc.product]) || doc.product || '';
                }
                var indexOfFirstSep = key.source.indexOf('.');
                var subKey = key.source.substring(indexOfFirstSep + 1);
                var valueFind = getPropsByKeyPath(doc.content, subKey);
                if (valueFind) {
                    if (key.translation && i18n) {
                        var translatedValueOptional = getPropsByKeyPath(i18n.keyValueMap, key.translation.substring(3, key.translation.length - 2).replace('$source', valueFind));
                        if (!translatedValueOptional) {
                            console.warn("Could not find the translation for the key ".concat(JSON.stringify(key), " rendering the raw value ").concat(valueFind));
                        }
                        var translatedValue = translatedValueOptional ? translatedValueOptional : valueFind;
                        text = text ? "".concat(text).concat(finalDelimiter).concat(translatedValue) : translatedValue;
                        textParts.push(translatedValue);
                    }
                    else {
                        text = text ? "".concat(text).concat(finalDelimiter).concat(valueFind) : valueFind;
                        textParts.push(valueFind);
                    }
                }
            });
            switch (type) {
                case E_COLUMN_SEARCH_TYPE.DATE: {
                    return {
                        text: text ? convertToDate(E_DATE_TYPE.DATE, text) : '',
                        style: style,
                    };
                }
                case E_COLUMN_SEARCH_TYPE.SET: {
                    return {
                        text: convertTextPartsToSetText(textParts, finalDelimiter),
                        style: style,
                    };
                }
                case E_COLUMN_SEARCH_TYPE.TIME_LEFT: {
                    return {
                        text: text ? convertToDate(E_DATE_TYPE.SINCE, text) : '',
                        style: style,
                    };
                }
                default: {
                    return {
                        text: text,
                        style: style,
                    };
                }
            }
        });
        var isLocked = checkIfCaseIsLocked(userInfo, doc);
        return {
            id: doc.id,
            product: doc.product,
            isLocked: isLocked,
            lockedBy: isLocked ? (_c = (_b = (_a = doc.content) === null || _a === void 0 ? void 0 : _a.currentLock) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.username : null,
            values: columnValues,
        };
    });
};
export var parseSubRowInformation = function (item) {
    var dataType = item.dataType, labelItem = item.label, value = item.value, valueTranslation = item.valueTranslation, format = item.format, key = item.key;
    var label = (labelItem || {}).label;
    var valueProcessed = valueTranslation || value;
    // use for retro compatibility
    if (valueExist(labelItem) && typeof labelItem === 'string' && valueExist(value) && typeof value === 'string') {
        if (dataType === E_DATE_TYPE.DATE && !!format) {
            // @ts-ignore
            return { value: convertToDate(format, value), label: labelItem, key: key };
        }
        return { value: valueProcessed, label: labelItem, key: key };
    }
    else if (valueExist(label) && typeof label === 'string' && valueExist(value) && typeof value === 'string') {
        if (dataType === E_DATE_TYPE.DATE && !!format) {
            // @ts-ignore
            return { value: convertToDate(format, value), label: label, key: key };
        }
        return { value: valueProcessed, label: label, key: key };
    }
    else if (valueExist(label) && typeof label === 'string') {
        // label good only
        console.warn('%cWarning on information format: value could have mismatch format, should be a string', 'color: #FFBD00', item);
        return { value: null, label: label, key: key };
    }
    else if (valueExist(value) && typeof value === 'string') {
        // value good only
        console.warn('%cWarning on information format: label could have mismatch format, should be a string', 'color: #FFBD00', item);
        if (dataType === E_DATE_TYPE.DATE && !!format) {
            // @ts-ignore
            return { value: convertToDate(format, value), label: '', key: key };
        }
        return { value: valueProcessed, label: '', key: key };
    }
    else {
        console.warn('An error occur on information format, be sure to get label and value of type string and at least one of them define', item);
        return { value: valueProcessed, label: label || labelItem, key: key };
    }
};
export var getIconsPath = function (icon) {
    var userIcon = E_ICONS.USER;
    var groupIcon = E_ICONS.GROUP;
    var folderIcon = E_ICONS.FOLDER;
    switch (icon) {
        case 'user': {
            return userIcon;
        }
        case 'user-group': {
            return groupIcon;
        }
        case 'global': {
            return folderIcon;
        }
        default:
            return null;
    }
};
export var getIdentityColors = function (status) {
    switch (status) {
        case E_IDENTITY_STATUS.NEVER_COMPLETED:
            return { color: COLORS.RED['500'], backgroundColor: COLORS.RED['100'] };
        case E_IDENTITY_STATUS.INCOMPLETE:
            return { color: COLORS.GRAY['500'], backgroundColor: COLORS.GRAY['100'] };
        case E_IDENTITY_STATUS.VALID:
            return { color: COLORS.GREEN['500'], backgroundColor: COLORS.GREEN['100'] };
        case E_IDENTITY_STATUS.TO_STUDY:
            return { color: COLORS.PRIMARY['500'], backgroundColor: COLORS.PRIMARY['100'] };
        case E_IDENTITY_STATUS.FRAUD:
        case E_IDENTITY_STATUS.FEB_EXCEPTION:
        default: {
            return { color: COLORS.BLACK, backgroundColor: COLORS.GRAY['100'] };
        }
    }
};
export var limitApplicantTabs = function (tabs) {
    var TAB_TO_DISPLAY_ON_LIMIT = 1; // If more than 3 applicant tab, we will display only 1 applicant tab
    var nbOfApplicantTab = tabs.filter(function (tab) { return valueExist(tab.applicantNum); }).length;
    var tab = tabs.reduce(function (acc, item) {
        var isOutOfBound = valueExist(item.applicantNum) &&
            nbOfApplicantTab > MAX_APPLICANTS_TO_DISPLAY &&
            acc.nbOfApplicantTab >= TAB_TO_DISPLAY_ON_LIMIT;
        if (isOutOfBound) {
            return acc;
        }
        var newApplicantTabCount = valueExist(item.applicantNum) ? acc.nbOfApplicantTab + 1 : acc.nbOfApplicantTab;
        return {
            result: __spreadArray(__spreadArray([], acc.result, true), [item], false),
            nbOfApplicantTab: newApplicantTabCount,
        };
    }, { result: [], nbOfApplicantTab: 0 });
    return tab.result;
};
export var getTabApplicant = function (applicantNum, applicants, isCompressed, currentApplicant) {
    var _a;
    var isApplicantTab = valueExist(applicantNum);
    if (!isApplicantTab) {
        return null;
    }
    if (isCompressed && currentApplicant) {
        return currentApplicant;
    }
    return (_a = applicants.at(applicantNum)) !== null && _a !== void 0 ? _a : null;
};
export var getNumberedApplicantTooltip = function (template, applicants, applicant) {
    var applicantNumber = applicants.findIndex(function (item) { return item.id === applicant.id; }) + 1;
    return template.replace(APPLICANT_NUMBER_PLACEHOLDER, String(applicantNumber));
};
export var parseInformationTab = function (caseInformation, applicants, isIdentityDisplayed, currentApplicant, compressedTooltipTemplate) {
    if (!caseInformation) {
        return [];
    }
    var tabs = caseInformation.tabs;
    var isCompressed = applicants.length > MAX_APPLICANTS_TO_DISPLAY;
    var tabToDisplay = limitApplicantTabs(tabs).map(function (tab) {
        var title = tab.title, icon = tab.icon, applicantNum = tab.applicantNum;
        var applicant = getTabApplicant(applicantNum, applicants, isCompressed, currentApplicant);
        var hasNumberedTooltip = isCompressed && !!applicant && !!compressedTooltipTemplate;
        var tooltip = hasNumberedTooltip
            ? getNumberedApplicantTooltip(compressedTooltipTemplate, applicants, applicant)
            : title;
        return {
            id: generateUUID(),
            icon: getIconsPath(icon),
            colors: isIdentityDisplayed && (applicant === null || applicant === void 0 ? void 0 : applicant.identityStatus) ? getIdentityColors(applicant.identityStatus) : null,
            label: title,
            applicantId: applicant ? applicant.id : null,
            tooltip: tooltip,
        };
    });
    return tabToDisplay;
};
export var parseInformationData = function (information, applicants) {
    if (information && information.tabs) {
        return information.tabs.map(function (item, index) {
            var applicant = applicants.at(index);
            var isApplicantTab = valueExist(item.applicantNum) && applicant;
            return {
                applicantId: isApplicantTab ? applicant.id : null,
                identity: isApplicantTab &&
                    (applicant.identityStatus || applicant.identityStatusReason || applicant.identityStatusLastUpdateTime)
                    ? {
                        status: applicant.identityStatus,
                        reason: applicant.identityStatusReason,
                        lastIdentityStatusUpdateTime: applicant.identityStatus === E_IDENTITY_STATUS.TO_STUDY ? applicant.identityStatusLastUpdateTime : null,
                    }
                    : null,
                data: item.rows.map(function (row) { return row.map(function (rowSub) { return rowSub.map(parseSubRowInformation); }); }),
            };
        });
    }
    return [];
};
export var processingActionStateExpression = function (actionState, caseDataPayload) {
    return actionState.some(function (action) {
        var ifCaseExpression = action.ifCaseExpression;
        if (!ifCaseExpression) {
            return false;
        }
        return jexl.evalSync(ifCaseExpression, caseDataPayload);
    });
};
export var calculateActionTypeOfButton = function (action) {
    switch (action.type) {
        case 'accept-application':
            return EButtonType.VALID;
        case 'reject-application':
            return EButtonType.ABORT;
        default:
            return EButtonType.NEUTRAL;
    }
};
// From old MO, BPMN should specify max number of button shown on screen
// caseDataPayload is required to processing expression of each action, done with jexl eval on old MO
export var parseCaseActions = function (actions, caseDataPayload, maxButtonDisplayed) {
    if (maxButtonDisplayed === void 0) { maxButtonDisplayed = 3; }
    var nbOfButtonDisplayed = 0;
    return actions
        .filter(function (action) {
        var isExpressionVerified = processingActionStateExpression(action.states, caseDataPayload);
        return !(action.hidden || isExpressionVerified || !!!action.link);
    })
        .map(function (action) {
        var canBeDisplayed = maxButtonDisplayed > nbOfButtonDisplayed && !action.menuAction;
        if (canBeDisplayed) {
            nbOfButtonDisplayed = nbOfButtonDisplayed + 1;
        }
        return {
            type: calculateActionTypeOfButton(action),
            label: action.label,
            link: action.link,
            disabled: action.disabled,
            isExtra: !canBeDisplayed,
            confirmationModal: action.confirmationModal || null,
        };
    });
};
export var reformatContractsBundle = function (i18n, contractsBundles) {
    if (contractsBundles.length < 1) {
        return [];
    }
    var bundleLabel = getPropsByKeyPath(i18n, 'modules.downloadActionModal.subTitleContract');
    var contractLabel = getPropsByKeyPath(i18n, 'modules.downloadActionModal.contract');
    return contractsBundles
        .sort(function (a, b) { return a.index - b.index; })
        .map(function (bundle) {
        return {
            label: [bundleLabel, bundle.index + 1].join(' '),
            contracts: bundle.contracts.map(function (contract) {
                return {
                    label: contract.label || (contractLabel === null || contractLabel === void 0 ? void 0 : contractLabel.replace('$num', contract.index + 1)),
                    fileUrl: contract.link,
                    signed: !!contract.signed,
                };
            }),
        };
    });
};
export var retrieveApplicantIndex = function (applicants, applicantId) {
    var applicantsIndex = applicants.findIndex(function (applicant) { return applicant.id === applicantId; });
    return applicantsIndex !== -1 ? applicantsIndex : null;
};
// Keep updated document data related to the applicant id
export var keepUpdatedDocumentDataOfApplicants = function (currentApplicants, applicants) {
    return applicants.map(function (applicant) {
        var currentApplicant = currentApplicants.find(function (currApplicant) { return applicant.id === currApplicant.id; });
        return __assign(__assign({}, applicant), { updatedDocumentData: currentApplicant === null || currentApplicant === void 0 ? void 0 : currentApplicant.updatedDocumentData });
    });
};
export var getDocumentsByApplicant = function (studyElements) {
    return studyElements.reduce(function (acc, curr) {
        var _a;
        var applicantId = curr.applicantId, restCurr = __rest(curr, ["applicantId"]);
        var previousCurr = acc[applicantId] || {};
        return __assign(__assign({}, acc), (_a = {}, _a[applicantId] = {
            documents: __spreadArray(__spreadArray([], (previousCurr.documents || []), true), [restCurr], false),
        }, _a));
    }, {});
};
export var enhanceDocumentWithFiles = function (files, filesUrls) {
    return files.reduce(function (acc, curr) {
        var _a = filesUrls[curr.url] || {}, file = _a.file, isLoading = _a.isLoading, isError = _a.isError, fileUpdated = _a.fileUpdated, type = _a.type, mimeType = _a.mimeType;
        // If file is not already requested or if file is null and wasn't in error meaning is loading
        if (!filesUrls[curr.url] || filesUrls[curr.url].file === null) {
            var defaultFile = {
                id: curr.url,
                name: curr.name,
                src: null,
                isLoading: !!isLoading,
                type: null,
                mimeType: null,
                isError: !!isError || !!!file,
            };
            return __spreadArray(__spreadArray([], acc, true), [defaultFile], false);
        }
        // for pdf which bundle multiple page, split multiple src in unique file lead to easier manipulation in view
        var flattenSrc = (file === null || file === void 0 ? void 0 : file.map(function (fileSrc, fileIndex) { return ({
            id: curr.url,
            name: curr.name,
            src: (fileUpdated === null || fileUpdated === void 0 ? void 0 : fileUpdated.at(fileIndex)) || fileSrc,
            isLoading: isLoading,
            type: type,
            mimeType: mimeType,
            isError: isError || !!!fileSrc,
        }); })) || [];
        return __spreadArray(__spreadArray([], acc, true), flattenSrc, true);
    }, []);
};
export var prepareDocumentFilesForView = function (item) {
    var _a, _b, _c, _d;
    // Preview can't be video so we set it to first image founded in files,
    // if no image the placeholder will take the lead
    var firstImageFileIndex = (_a = item.files) === null || _a === void 0 ? void 0 : _a.findIndex(function (src) { return src.type === E_FILE_TYPE.IMAGE; });
    if (item.isFilesToMerge) {
        var sourceMerged = mergeFiles((_b = item.files) === null || _b === void 0 ? void 0 : _b.map(function (file) { return file.src; }));
        return __assign(__assign({}, item), { preview: sourceMerged, files: [
                {
                    id: item.id,
                    name: item.label,
                    src: sourceMerged,
                    isLoading: false,
                    isError: false,
                    type: E_FILE_TYPE.IMAGE,
                    mimeType: 'image/jpeg',
                },
            ] });
    }
    return __assign(__assign({}, item), { preview: (_d = (_c = item.files) === null || _c === void 0 ? void 0 : _c.at(firstImageFileIndex)) === null || _d === void 0 ? void 0 : _d.src });
};
